import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const AboutTimeline = ({ items }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 75%", "end 55%"],
  });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <div ref={ref} className="relative max-w-4xl mx-auto mt-16">
      {/* line track */}
      <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-ink/15 md:-translate-x-1/2" />
      {/* animated through-line */}
      <motion.div
        style={{ scaleY }}
        className="absolute left-4 md:left-1/2 top-0 bottom-0 w-[3px] bg-windsor origin-top md:-translate-x-1/2"
      />

      {items.map((t, i) => {
        const left = i % 2 === 0;
        return (
          <div key={t.year} className="relative md:grid md:grid-cols-2 md:gap-16 md:items-center">
            <motion.span
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.4, ease: "backOut" }}
              className="absolute left-4 md:left-1/2 top-9 w-4 h-4 rounded-full bg-windsor ring-4 ring-ivory -translate-x-1/2 z-10"
            />
            <motion.div
              initial={{ opacity: 0, x: left ? -50 : 50, y: 20 }}
              whileInView={{ opacity: 1, x: 0, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className={`pl-12 md:pl-0 py-8 ${
                left ? "md:pr-16 md:text-right" : "md:col-start-2 md:pl-16"
              }`}
            >
              <p className="font-serif text-2xl md:text-3xl text-windsor">{t.year}</p>
              <h3 className="font-serif text-2xl text-ink font-semibold leading-tight mt-1">{t.title}</h3>
              <p className="text-ink font-normal leading-relaxed mt-3">{t.body}</p>
            </motion.div>
          </div>
        );
      })}
    </div>
  );
};
